// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"100":"forgot-password","710":"buyer-registration"}[chunkId] + "." + {"100":"af6a8fc0","710":"a4e47afd"}[chunkId] + ".css";
};